import React from 'react';
import Button from '@material-ui/core/Button';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Typography from '@material-ui/core/Typography';
import { Grid, Box, Link } from "@material-ui/core";
import { AppRouteURI } from "router/RoleBasedAccess";

const ThankyouDialog = (classes, history, handleResendEmail) => {
    return (
        <>
            <DialogContent style={{ padding: '0px' }}>
                <Typography className={classes.thankyouTitle}>
                Thank you for Signing Up
                </Typography>
            <Typography gutterBottom className={classes.thankyouContent}>
                <p>Your account is now active. Please return to the Main Page to sign in.</p>
                {/* <p>Before you can get started, please check your email for a verification email. 
                If it isn’t in your inbox, please check your spam folders. </p>
                Didn’t get an email? <Link className={classes.link} onClick={handleResendEmail}><u>Click here</u></Link> to send it again. */}
            </Typography>
            <DialogActions className={classes.thankyouActions}>
                <Grid 
                    container
                    direction="column"
                    justifyContent="space-evenly"
                    alignItems="center"
                >
                    {/* <Grid item xs={12} className={classes.redirectToPublic} onClick={() => {history.push(AppRouteURI.SCENARIO)}}>
                        <Box>
                            <Button variant="outlined" style={{fontSize: "20px"}}>Go to Public view</Button>
                        </Box>
                    </Grid> */}
                    <Grid item xs={12}>
                        <Box>
                            <Button variant="outlined" style={{fontSize:"20px"}} className={classes.redirectToHome} onClick={() => {history.push(AppRouteURI.HOME)}}>
                                Return to Main Page
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
            </DialogActions>
            </DialogContent>
        </>
    )
}

export default ThankyouDialog;